import React from "react";
import styled from "styled-components/macro";
import {compose, layout, space} from "styled-system";
import { css as cssHelper} from '@styled-system/css';
import Header from './ui/Header';

const Parallax = styled.div`
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: top;
  background-color: ${props => props.theme.colors.header};
  color: #fafafa;
  width: 100%;
  height: 75vh;
`;

const Splash = styled.div`
  font-size: 3.5rem;
  //padding-left: 50px;
  padding-top: 15vh;//200px;
  color: #fafafa;
  text-align: center;
  //height: 9rem;
  //width: 12rem;
  font-family: ${props => props.theme.fontLogo}
  
  ${compose(space, layout)}
`;

const ScrollSuggest = styled.div`
  color: #fafafa;
  text-align: center;
  font-family: ${props => props.theme.fontHeader};
  font-size: 2rem;
  position: absolute;
  bottom: 20px;
  left: calc(50vw - 6rem);
`;

const Banner = styled.div`
  font-size: 3rem;
  text-align: center;
  background-color: black;
  color: white;
  font-family: ${props => props.theme.fontHeader};
  max-height: ${props => props.maxheight || '50vh'};
  padding-top: 20vh;
  padding-bottom: 20vh;

  ${compose(space, layout)}
`;

const FullBanner = styled(Banner)`
  height: 100vh;
  max-height: 100vh;
`

const BannerBody = styled.div`
  ${cssHelper({
    marginTop: [5]
  })}
  font-size: 2rem;
  font-family: ${props => props.theme.fontBody};
  
  ${space}
`;

export default function Home() {
  return (
    <>
      <Header>
        <Splash>
          Marshal<br/>Carter<br/>& Dark
        </Splash>
        <ScrollSuggest style={{bottom: '0px', fontSize: '2rem', color: 'white'}}>
          Scroll down<br/>to learn more<br/>
          <span style={{fontSize: '60px'}} className="material-icons">expand_more</span>
        </ScrollSuggest>
      </Header>
      <Banner>
        A cozy country office.
        <BannerBody>
          We've always been here.
        </BannerBody>
      </Banner>
      <Parallax image='https://images.pexels.com/photos/235986/pexels-photo-235986.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'/>
      <Banner>
        Just at the end of the road.
        <BannerBody>
          Don't get lost.
        </BannerBody>
      </Banner>
      <Parallax image='https://images.pexels.com/photos/1591447/pexels-photo-1591447.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260'/>
      <Banner>
        Looking over your shoulder.
        <BannerBody>
          Never be alone.
        </BannerBody>
      </Banner>
      <Parallax image='https://images.pexels.com/photos/242201/pexels-photo-242201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'/>
      <FullBanner>
        <Splash>
          Marshall, Carter & Dark
        </Splash>
        <BannerBody style={{fontFamily: '\'Playfair Display\''}}>
          Lawsuits can be scary.
        </BannerBody>
        <BannerBody style={{fontSize: '1rem'}}>
          Don't be frightened of your lawyer.
        </BannerBody>
      </FullBanner>
    </>
  );
}